<template>

  <div class="height-100">
    
    <creating
      v-if="creating"
      height="100%" />

    <div
      class="vflex"
      v-if="!creating"
      :class="{'box-loading': loading}">

      <div class="vflex-row-0 vflex-header p-3">
        <div class="page-title">
          <div class="title">
            <h4>
              {{ dashboard.fixed ? $t(dashboard.name) : dashboard.name }}
              <span
                v-if="dashboard.advanced"
                class="badge badge-secondary"
                style="font-size: 12px">Avançado</span>
            </h4>
          </div>
          <div class="btn-row">
            <div class="form-inline">
              <button
                type="button"
                class="btn btn-primary mr-2"
                v-if="permissions.includes('manage_settings') && dashboard.fixed === false"
                @click="showCreateReportModal({ dashboard_id: dashboard._id })">
                {{ $t('New report') }}
              </button>

              <div
                class="btn-group"
                v-if="permissions.includes('manage_settings') && dashboard.fixed === false">
                <button
                  type="button"
                  @click="showEditModal(dashboard)"
                  class="btn btn-light">
                  {{ $t('Edit') }}
                  </button>
                <button
                  type="button"
                  class="btn btn-light dropdown-toggle dropdown-toggle-split"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right">
                  <button
                    class="dropdown-item"
                    @click="deleteDashboard(dashboard._id)">{{ $t('Delete') }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vflex-row-0 vflex-header p-3">
        <div class="form-inline" style="display: flex; justify-content: flex-end; ">
          <div
            class="mr-2">
            <SelectCompany
              placeholder="Empresa"
              style="min-width: 140px;"
              :value="reportingFilters.global_company_id"
              @input="setFilter('global_company_id', $event)" />
          </div>
          <div
            class="mr-2">
            <SelectDepartament
              placeholder="Departamento"
              style="min-width: 140px;"
              :value="reportingFilters.global_departament_id"
              @input="setFilter('global_departament_id', $event)" />
          </div>
          <!--<div
            class="mr-2">
            <SelectUser
              placeholder="Usuário"
              style="min-width: 140px;"
              :value="reportingFilters.global_user_id"
              @input="setFilter('global_user_id', $event)" />
          </div>-->

          <div
            class="mr-2">
            <RangeDate
              :value="reportingFilters.date"
              @input="setFilter('date', $event)"
              style="min-width: 210px;" />
          </div>

          </div>
      </div>

      <div class="vflex-row-1">
        <DashcomponentMosaic
          v-if="dashcomponentsLength"
          :dashboardId="dashboard._id"
          :dashcomponents="dashboard.dashcomponents" />
        <div
          v-if="!dashcomponentsLength"
          class="p-3 text-muted">
          <h5>Não há relatórios.</h5>
          <p>Adicione relatórios ao seu painel para começar a analisar e melhorar seu processo de contratação!</p>
        </div>

        <DashboardForm
          v-if="modal_select"
          :initDashboard="modal_select" 
          @hideModal="hideModal()"
          @deleted="loadData(); hideModal()" 
          @saved="loadData(); hideModal()" />

        <DashcomponentForm
          v-if="modal_report_select"
          :initDashcomponent="modal_report_select" 
          @hideModal="hideReportModal()"
          @deleted="loadData(); hideReportModal()" 
          @saved="loadData(); hideReportModal()" />

      </div>

    </div>

  </div>

</template>

<script>
import DashboardForm from './DashboardForm'
import DashcomponentForm from './DashcomponentForm'
import DashcomponentMosaic from './DashcomponentMosaic'
import RangeDate from '@/components/Fields/RangeDate'
import SelectCompany from '@/components/Fields/SelectCompany'
import SelectDepartament from '@/components/Fields/SelectDepartament'
// import SelectUser from '@/components/Fields/SelectUser'

export default {
  name: 'DashboardItem',
  components: {
    DashboardForm,
    DashcomponentForm,
    DashcomponentMosaic,
    RangeDate,
    SelectCompany,
    SelectDepartament
    // SelectUser
  },
  props: {
  },
  data () {
    return {
      creating: true,
      modal_select: false,
      modal_report_select: false,
      loading: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    reportingFilters () {
      return this.$store.getters.getReportingFilters
    },
    dashboardId () {
      return this.$route.params.id
    },
    dashboard () {
      return this.$store.getters.getDashboard
    },
    dashcomponentsLength () {
      const items = this.dashboard.dashcomponents
      return items && items.length >= 1
    }
  },
  metaInfo () {
    return {
      title: this.creating ? 'Carregando...' : this.dashboard.title
    }
  },
  watch: {
    dashboardId (value) {
      this.creating = true
      this.loadData()
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      return this.$store.dispatch('selectDashboard', this.dashboardId)
      .then(() => {
        this.creating = false
      })
    },
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {}
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    report modal
    */
    showCreateReportModal (data) {
      this.modal_report_select = data
    },
    showEditReportModal (item) {
      this.modal_report_select = item
    },
    hideReportModal () {
      this.modal_report_select = false
    },
    /*
    delete
    */
    deleteDashboard (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteDashboard', id)
        .then((result) => {
          this.loading = false
          this.$router.push({ path: '/dashboards' })
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    },
    setFilter (key, value) {
      this.$store.dispatch('setReportingFilter', {
        ...this.reportingFilters,
        [key]: value
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/DashboardItem.vue